import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import useCampaigns from 'hooks/useCampaigns';
import useCampaignsSummary from 'hooks/useCampaignsSummary';
import { Link } from 'react-router-dom';
import { PAGE_NAV } from 'configs/page';
import { currencyFormatter, numberFormatter } from 'utils/formatter';
import moment from 'moment';
import Skeleton from "react-loading-skeleton";

// Generates 13 month options starting from the current month going backwards
const generatePrevious12Months = (startDate) => {
    const monthsList = [];
    for (let i = 0; i <= 12; i++) {
        const d = new Date(startDate.getFullYear(), startDate.getMonth() - i, 1);
        const label = new Intl.DateTimeFormat('en-US', { month: 'short', year: 'numeric'/*'2-digit'*/}).format(d);
        monthsList.push({ label, value: moment(d).format("YYYY/MM/DD") });
    }
    return monthsList;
};

const CampaignList = ({
    campaignSelectionValue,
    onCampaignSelectionChange,
    selectedMonth,
    onMonthChange,
    breakdownData,
    isFetching,
}) => {
    const { dateRangeID } = useCampaigns();
    const { data: campaignList } = useCampaignsSummary(dateRangeID);

    const campaignSelectionRef = useRef(null);
    const [campaignSelectionOn, setCampaignSelectionOn] = useState(false);

    const [hoveredId, setHoveredId] = useState(null);

    const [isClicked, setIsClicked] = useState(false);
    
    const handleHoveredClicked = (id)=>{
        
        setHoveredId(prev=>{
            if(prev != id) {
                return id;
            }
            return null;
        });
        setIsClicked(prev=>!prev);
    }

    const dateSelectionRef = useRef(null);
    const [dateSelectionOn, setDateSelectionOn] = useState(false);

    const options = generatePrevious12Months(new Date());

    const handleCampaignSelection = (value) => {
        onCampaignSelectionChange(value);
        setCampaignSelectionOn(false);
    };

    const handleMonthChange = (val) => {
        onMonthChange(val);
        setDateSelectionOn(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (campaignSelectionRef.current && !campaignSelectionRef.current.contains(event.target))
                setCampaignSelectionOn(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => { document.removeEventListener("mousedown", handleClickOutside); };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dateSelectionRef.current && !dateSelectionRef.current.contains(event.target))
                setDateSelectionOn(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => { document.removeEventListener("mousedown", handleClickOutside); };
    }, []);

    useEffect(() => {
        function handleClickOutside(e) {
            if (hoveredId) {
                setHoveredId(null);
                setIsClicked(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [hoveredId]);

    return (
        <div>
            <div className={classNames("section", "my-compaign", "card-group")}>
                <div className={classNames('card', 'campaign')}>
                    <div className='card-header'>
                        <div ref={campaignSelectionRef} className={classNames('campaign-selection-list', 'selection-list', { on: campaignSelectionOn })}>
                            <select
                                className='table-select'
                                value={campaignSelectionValue}
                                onChange={(e)=>{e.preventDefault(); handleCampaignSelection(e.target.value)}}
                                >
                                <option value="-1">All campaigns</option>
                                {
                                    campaignList?.StatsSummaries
                                    && [...campaignList.StatsSummaries]
                                        .map(c => ({
                                            ...c,
                                            CampaignDetail: {
                                                ...c.CampaignDetail,
                                                Title: c.CampaignDetail.Title || 'Campaign',
                                            }
                                        }))
                                        .sort((a, b) => a.CampaignDetail.Title.toLowerCase() > b.CampaignDetail.Title.toLowerCase() ? 1 : -1)
                                        .map((item, i) => (
                                            <option 
                                                key={`campaignItm_${i}`}
                                                value={item.CampaignDetail.CampaignID}
                                                >{item.CampaignDetail.Title}</option>
                                        ))
                                }
                            </select>
                            
                            {/* <p className='selection-value' onClick={() => setCampaignSelectionOn(!campaignSelectionOn)}>
                                <span className='campaign-title'>
                                    {
                                        campaignSelectionValue < 1
                                        ? 'All campaigns'
                                        : campaignList?.StatsSummaries?.find(itm => itm.CampaignDetail.CampaignID === campaignSelectionValue)
                                          ?.CampaignDetail.Title ?? 'All campaigns'
                                    }
                                </span>
                                {campaignSelectionOn
                                    ? <FontAwesomeIcon className='arrow-up-ico' icon={faChevronUp} />
                                    : <FontAwesomeIcon className='arrow-down-ico' icon={faChevronDown} />}
                            </p>
                            <ul className='selection-option-list'>
                                <li>
                                    <a
                                        className={classNames('selection-item', { 'on': campaignSelectionValue < 1 })}
                                        onClick={() => handleCampaignSelection(0)}
                                    >All campaigns</a>
                                </li>
                                {
                                    campaignList?.StatsSummaries
                                    && [...campaignList.StatsSummaries]
                                        .map(c => ({
                                            ...c,
                                            CampaignDetail: {
                                                ...c.CampaignDetail,
                                                Title: c.CampaignDetail.Title || 'Campaign',
                                            }
                                        }))
                                        .sort((a, b) => a.CampaignDetail.Title.toLowerCase() > b.CampaignDetail.Title.toLowerCase() ? 1 : -1)
                                        .map((item, i) => (
                                            <li key={i}>
                                                <a
                                                    className={classNames('selection-item', { 'on': item.CampaignDetail.CampaignID === campaignSelectionValue })}
                                                    onClick={() => handleCampaignSelection(item.CampaignDetail.CampaignID)}
                                                >{item.CampaignDetail.Title}</a>
                                            </li>
                                        ))
                                }
                            </ul> */}
                        </div>

                        {/* {campaignSelectionValue > 0 &&
                            <p className="campaign-link">
                                <Link to={`campaigns/${campaignSelectionValue}`} title="campaign details page">
                                    <span>View</span>
                                </Link>
                            </p>
                        } */}

                        <p className="add-campaign">
                            <Link to={PAGE_NAV.CAMPAIGN_ADD} title="Add campaign">
                                {/* <FontAwesomeIcon className='plus-ico' icon={faPlus} />  */}
                                <span>Add</span>
                            </Link>
                        </p>
                    </div>
                    <div className='card-content'>
                        <table className="compaign-table">
                            <thead className={classNames("thead")}>
                                <tr>
                                    <th>
                                        <div ref={dateSelectionRef} className={classNames('date-selection-list', 'selection-list', { on: dateSelectionOn })}>
                                            <span className='selection-value' onClick={() => setDateSelectionOn(!dateSelectionOn)}>
                                                <span className='month-year'>{options.find(opt => opt.value === selectedMonth)?.label}</span>
                                                <FontAwesomeIcon className='arrow-down-ico' icon={faChevronDown} />
                                            </span>
                                            <ul className='selection-option-list'>
                                                {options.map((opt) => (
                                                    <li key={opt.value}>
                                                        <a
                                                            className={classNames('selection-item', { 'on': selectedMonth === opt.value })}
                                                            onClick={() => handleMonthChange(opt.value)}
                                                        >{opt.label}</a>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </th>
                                    <th>Joins</th>
                                    <th>Sales</th>
                                    <th>Earnings</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    isFetching
                                    ? [1, 2, 3, 4, 5].map(itm => (
                                        <tr key={`sk_${itm}`}>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                        </tr>
                                    ))
                                    : breakdownData && breakdownData.length > 0
                                      ? breakdownData.map(itm => {
                                        const rowid = `campaign_${campaignSelectionValue}_${moment(itm.Date).format("YYYY_MM_DD")}`;
                                        return (
                                            <tr key={rowid}>
                                                <td>
                                                    <span className='campaign-date'>
                                                        {new Intl.DateTimeFormat('en-US', { weekday: 'short', day: 'numeric' }).format(moment(itm.Date).toDate())}
                                                    </span>
                                                </td>
                                                <td>
                                                    {itm.Joins > 0 ? numberFormatter.format(itm.Joins) : '-'} 
                                                    {/* {itm.Traffic > 0 && itm.Joins > 0 ? `(${Math.round(itm.Joins * 100 / itm.Traffic)}%)` : ``} */}
                                                </td>
                                                <td>
                                                    {itm.Upgrades > 0 ? numberFormatter.format(itm.Upgrades) : '-'}
                                                    {/* {itm.Upgrades > 0 && itm.Joins > 0 ? `(${Math.round(itm.Upgrades * 100 / itm.Joins)}%)` : ``} */}
                                                </td>
                                                <td className='tooltip'>
                                                    <span translate="no" className="notranslate"
                                                       onClick={()=>{  if(itm.Revenue > 0){ handleHoveredClicked(rowid)}}}
                                                        onMouseEnter={() => { itm.Revenue > 0 && setHoveredId(rowid)}}
                                                        onMouseLeave={() => { itm.Revenue > 0 && !isClicked && setHoveredId(null)}}>
                                                            {itm.Revenue > 0 ? currencyFormatter.format(itm.Revenue) : '-'}
                                                    </span>
                                                    {   hoveredId==rowid 
                                                        && 
                                                        <em className='tooltip-bubble'>
                                                            <span className='title'>Earnings breakdown</span>
                                                            <span>Commission: <span translate="no" className="notranslate val">{currencyFormatter.format(itm.Revenue - (itm.RevenueQL??0))}</span></span>
                                                            <span className='ql'><span>Bonus:</span> <span translate="no" className={classNames("notranslate val", {"dash":!itm.RevenueQL || itm.RevenueQL < 1})}>{(itm.RevenueQL && itm.RevenueQL > 0) ? currencyFormatter.format(itm.RevenueQL) : '-'}</span></span>

                                                        </em>
                                                    }
                                                    
                                                </td>
                                            </tr>
                                        )})
                                      : <tr><td colSpan={4} align="center" style={{ textAlign: 'center' }}>No result found</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CampaignList;
